import React, { useState } from 'react';

const ChatGPTChat = () => {
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');

  const sendMessage = async () => {
    if (inputText.trim() === '') return;

    // Add user message to chat window
    const userMessage = { text: inputText, sender: 'user', role: 'user' };
    const updatedMessages = [...messages, userMessage];
    setMessages(updatedMessages);

    console.log("Sending message to ChatGPT:", userMessage.text);

    try {
      // Prepare the messages for ChatGPT API, sending the entire conversation history
      const apiMessages = updatedMessages.map((msg) => ({
        role: msg.role,
        content: msg.text,
      }));
      apiMessages.push({ role: 'system', content: 'Focus on Language Learning: Provide speaking practice, grammar exercises, and daily conversations.Stay Concise: Limit responses to 3-5 suggestions, with no more than 300 characters per response.Be Formal and Encouraging: Maintain a positive tone, helping users improve at their own pace.Avoid Sensitive Topics: Steer clear of discussions on sex or unrelated subjects.' });
      apiMessages.push({ role: 'system', content: 'Всегда отвечай на русском языке, даже если я пишу на английском' });

      // Fetch response from ChatGPT API (Chat API)
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer sk-proj-xGs20eUbJWgkIBGHUDCGT3BlbkFJK9KakRHkLLf9Xu3YJasZ`, // Add your API key here
        },
        body: JSON.stringify({
          model: 'gpt-4o', // Or 'gpt-3.5-turbo' for GPT-3.5
          messages: apiMessages, // Send the entire message history
        }),
      });

      const data = await response.json();
      const gptMessage = { text: data.choices[0].message.content.trim(), sender: 'gpt', role: 'assistant' };

      // Log GPT response
      console.log("Received response from ChatGPT:", gptMessage.text);

      // Add GPT response to chat window
      const newMessages = [...updatedMessages, gptMessage];
      setMessages(newMessages);

      // Call ElevenLabs API to play the GPT response
      await playResponse(gptMessage.text);
    } catch (error) {
      console.error('Error fetching GPT response:', error);
    }

    // Clear the input field after sending the message
    setInputText('');
  };

  const playResponse = async (text) => {
    const apiKey = 'sk_e78333a8a857b1aaa97acadece9548791b7cb853e88e2ebc'; // Replace with your ElevenLabs API key

    const requestData = {
      text: text,
      model_id: "eleven_turbo_v2_5",
      voice_settings: {
        stability: 0.5,
        similarity_boost: 0.5,
      },
    };

    console.log("Sending message to ElevenLabs for TTS:", requestData.text);

    try {
      const response = await fetch(
        'https://api.elevenlabs.io/v1/text-to-speech/N2lVS1w4EtoT3dr4eOWO?output_format=mp3_44100_128',
        {
          method: 'POST',
          headers: {
            'xi-api-key': apiKey,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        throw new Error('ElevenLabs API call failed');
      }

      // Receive the audio blob from ElevenLabs
      const audioBlob = await response.blob();
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      
      console.log("Received response from ElevenLabs, playing audio.");

      // Play the audio response
      audio.play();
    } catch (error) {
      console.error('Error fetching data from ElevenLabs:', error);
    }
  };

  return (
    <div style={styles.chatContainer}>
      <div style={styles.chatWindow}>
        {messages.map((msg, index) => (
          <div
            key={index}
            style={msg.sender === 'user' ? styles.userMessage : styles.gptMessage}
          >
            {msg.text}
          </div>
        ))}
      </div>
      <div style={styles.inputContainer}>
      <input
  type="text"
  value={inputText}
  onChange={(e) => setInputText(e.target.value)}
  onKeyDown={(e) => e.key === 'Enter' && sendMessage()} // Handle Enter key
  style={styles.input}
  placeholder="Type your message..."
/>

        <button onClick={sendMessage} style={styles.button}>Send</button>
      </div>
    </div>
  );
};

const styles = {
    chatContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100vw',
      maxWidth: '800px', // Set max width
      margin: '0 auto',  // Center horizontally
    },
    chatWindow: {
      flex: 1,
      padding: '10px',
      overflowY: 'auto',
      backgroundColor: '#f1f1f1',
      width: '100%', // Make sure it scales down
      boxSizing: 'border-box', // Ensure padding doesn't affect width
    },
  userMessage: {
    textAlign: 'right',
    padding: '10px',
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '10px',
    margin: '5px 0',
  },
  gptMessage: {
    textAlign: 'left',
    padding: '10px',
    backgroundColor: '#e1e1e1',
    borderRadius: '10px',
    margin: '5px 0',
  },
  inputContainer: {
    display: 'flex',
    padding: '10px',
    borderTop: '1px solid #ccc',
    backgroundColor: '#fff',
  },
  input: {
    flex: 1,
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  button: {
    marginLeft: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default ChatGPTChat;
